import { ContractorIndividualItem } from '../bus/contractorIndividual/types';
import $axios from '../utils/axios-instance';

export default class ContractorIndividualsApi {
  async getContractorIndividualList() {
    return await $axios
      .get<{ data: ContractorIndividualItem[] }>('/v1/ContractorIndividual')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorIndividualDetail(data: { id: number | string }) {
    return await $axios
      .get<ContractorIndividualItem>(`/v1/ContractorIndividual/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createContractorIndividual(data: Omit<ContractorIndividualItem, 'id'>) {
    return await $axios
      .post('/v1/ContractorIndividual', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeContractorIndividual(data: ContractorIndividualItem) {
    return await $axios
      .put(`/v1/ContractorIndividual/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteContractorIndividual(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/ContractorIndividual/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
